import React, { Component } from 'react';

export function wrapGrid (Comp) {
	return class extends Component {
		render () {

			return (
				<div className="grid-x">

					<div className="auto cell">
						<Comp { ...this.props } />
					</div>

				</div>
			);
		}
	}
}
